import validate from "/codebuild/output/src239773520/src/gx-booking/node_modules/.pnpm/nuxt@3.15.4_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_en_a1a286f120b921cfb9afba8203a11c0f/node_modules/nuxt/dist/pages/runtime/validate.js";
import account_45context_45slug_45global from "/codebuild/output/src239773520/src/gx-booking/middleware/account-context-slug.global.ts";
import auth_45check_45global from "/codebuild/output/src239773520/src/gx-booking/middleware/auth-check.global.ts";
import layout_45switcher_45global from "/codebuild/output/src239773520/src/gx-booking/middleware/layout-switcher.global.ts";
import trailing_45slash_45global from "/codebuild/output/src239773520/src/gx-booking/middleware/trailing-slash.global.ts";
import manifest_45route_45rule from "/codebuild/output/src239773520/src/gx-booking/node_modules/.pnpm/nuxt@3.15.4_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.2_en_a1a286f120b921cfb9afba8203a11c0f/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  account_45context_45slug_45global,
  auth_45check_45global,
  layout_45switcher_45global,
  trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}